import React from "react";

//@ts-ignore
import whatsappLogo from "../assets/images/logo-whatsapp.svg";

export default function FloatingWhatsappButton() {
  return (
    <a
      className="floating-whatsapp-button"
      href="https://wa.me/40758928165"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactează-ne pe WhatsApp"
    >
      <img src={whatsappLogo} alt="" aria-hidden="true" />
    </a>
  );
}
